import { render } from "./Program05.vue?vue&type=template&id=31fb4db1"
import script from "./Program05.vue?vue&type=script&lang=js"
export * from "./Program05.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__